<template>
  <div class="parkset">
    <div class="map">
      <!--右侧上方搜索框-->
      <div class="searchbox space_searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>岗位:</label>
            <search-area></search-area>
          </div>
          <div class="form-group">
            <label for>泊位编号:</label>
            <input
              v-model.trim="search.spaceNum"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group devSn">
            <label for>地磁编号:</label>
            <input
              v-model.trim="search.devSn"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>

          <div class="form-group space-status">
            <label for>泊位状态:</label>
            <el-select clearable v-model.trim="search.lotType">
              <el-option
                v-for="item in allSpaceStatus"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <el-button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="loading"
                size="small"
              >
                查询
              </el-button>
            </span>
          </div>
          <div class="form-group others">
            <span class="add_btn">
              <button
                v-if="parkset_btn_addSpace"
                type="button"
                class="btn btn-default"
                id="addarea"
                @click="addSpace"
              >
                添加
              </button>
            </span>
          </div>
          <div class="form-group others">
            <span class="batchImport_btn">
              <button
                v-if="parkset_btn_addSpace"
                type="button"
                class="btn btn-default"
                @click="batchImportSpace"
              >
                批量导入
              </button>
            </span>
          </div>

          <div class="form-group others">
            <button
              type="button"
              class="btn btn-default"
              @click="executeBatchDel"
            >
              批量删除
            </button>
          </div>
          <div class="form-group others">
            <el-button
              @click="tableListDataAllTwoNb"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="downloadLoading"
            >
              导出
            </el-button>
          </div>

          <div class="form-group others"></div>
        </form>
      </div>
      <!--车位列表信息展示-->
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
          @selection-change="checkedList"
          v-loading="loading"
        >
          <el-table-column
            show-overflow-tooltip
            type="selection"
            width="55"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="停车道路" prop="attr1">
          </el-table-column>
          <el-table-column show-overflow-tooltip label="岗位" prop="areaId">
            <template slot-scope="scope">
              {{
                scope.row.areaId != "" && scope.row.areaId != undefined
                  ? JSON.parse(scope.row.areaId).areaName
                  : ""
              }}
            </template>
          </el-table-column>

          <el-table-column
            show-overflow-tooltip
            label="泊位编号"
            prop="spaceNum"
          ></el-table-column>

          <el-table-column show-overflow-tooltip label="地磁编号">
            <template slot-scope="scope" >
            <span 
            @click="onDeviceSnClick(scope.row)"
            :style="{cursor:'pointer',borderBottom:'1px solid blue'}"
            >
              {{
              handleDevSnNum(scope.row.attr3)
            }}
            </span>
            </template>
          </el-table-column>
          <el-table-column v-if="BERTH_LIST_VIDEO_FIELD" show-overflow-tooltip label="高位视频编号">
            <template slot-scope="scope">{{
              scope.row.attr3 ? JSON.parse(scope.row.attr3).deviceCode : ""
            }}</template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="泊位类型"
            prop="spaceType"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="泊位状态"
            prop="lotType"
          >
            <template slot-scope="scope">{{
              scope.row.lotType | handleLotType
            }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="300px">
            <template slot-scope="scope">
              <template>
                <button
                  v-if="handleDevSnNum(scope.row.attr3)"
                  type="button"
                  class="bind is-gray"
                  @click="spaceUnbindEquipSure(scope.row.spaceId, 'dev')"
                >
                  地磁解绑
                </button>
                <button
                  v-else
                  type="button"
                  class="bind"
                  @click="spaceBindEquip(scope.row.spaceId)"
                >
                  地磁绑定
                </button>
              </template>

              <template>
                <template>
                  <button
                    v-if="
                      scope.row.attr3 && JSON.parse(scope.row.attr3).deviceCode
                    "
                    type="button"
                    class="bind is-gray"
                    @click="
                      spaceUnbindEquipSure(scope.row.spaceId, 'high-video')
                    "
                  >
                    高位视频解绑
                  </button>
                  <button
                    v-else
                    type="button"
                    class="bind"
                    @click="spaceBindHighVideo(scope.row.spaceId)"
                  >
                    高位视频绑定
                  </button>
                </template>
              </template>
              <button
                type="button"
                class="edit"
                @click="showQrCode(scope.row)"
              >
                二维码下载
              </button>
              <button
                type="button"
                class="edit"
                @click="editSpace(scope.row.spaceId)"
              >
                修改
              </button>
              <button
                type="button"
                class="delete"
                @click="delSpace(scope.row.spaceId)"
              >
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    <!-- 添加/编辑车位 -->
    <el-dialog
      title="添加/编辑车位"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisibleSpace"
      width="430px"
      @open="openDialogSpace"
      @close="closeDialogSpace"
    >
      <el-form
        ref="formSpace"
        label-position="right"
        :model="formSpace"
        :rules="rulesSpace"
        :label-width="formLabelWidth"
      >
        <el-form-item label="停车道路" prop="parkingId">
          <el-col :span="18">
            <el-select
              filterable
              clearable
              v-model="formSpace.parkingId"
              placeholder="请选择"
              @change="getAreasByParkingId"
            >
              <el-option
                v-for="item in parkingList"
                :key="item.parkingId"
                :label="item.parkingName"
                :value="item.parkingId"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <template>
          <el-form-item label="岗位" prop="areaId">
            <el-col :span="18">
              <el-select
                filterable
                clearable
                v-model="formSpace.areaId"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.areaId"
                  :label="item.areaName"
                  :value="item.areaId"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </template>

        <el-form-item label="泊位编号" prop="number">
          <el-col :span="18">
            <el-input v-model.trim="formSpace.number" auto-complete="off">
              <template slot="append">泊位</template>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="泊位类型">
          <el-col :span="18">
            <el-select
              @change="changeSpaceType"
              v-model.trim="formSpace.type"
              placeholder="请选择"
            >
              <el-option
                v-for="item in spaceAllType"
                :key="item.index"
                :label="item.labelZhCh"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addEditSpaceTrue">确 定</el-button>
        <el-button @click="dialogFormVisibleSpace = false">取 消</el-button>
      </div>
    </el-dialog>
    <!--高位视频绑定-->
    <el-dialog
      title="高位视频绑定"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogVisibleHighVideo"
      with="500px"
    >
      <div>
        <el-form
          ref="formHighVideo"
          label-position="right"
          :model="formHighVideo"
          :label-width="formLabelWidth"
        >
          <el-form-item label="道路" prop="parkingId">
            <el-col :span="18">
              <el-select
                clearable
                v-model.trim="formHighVideo.parkingId"
                filterable
                placeholder="请选择"
                style="width: 100%"
                @change="onRoadChange"
              >
                <el-option
                  v-for="item in parkingList"
                  :key="item.parkingId"
                  :label="item.parkingName"
                  :value="item.parkingId"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="高位视频" prop="highVideoSn">
            <el-col :span="18">
              <el-select
                clearable
                v-model.trim="formHighVideo.highVideoSn"
                filterable
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in highVideoList"
                  :key="item.id"
                  :label="item.deviceCode"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
        </el-form>
        <!-- <span v-if="!spaceUseEquip.length">暂无设备可绑定</span> -->
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="highVideoBindSpaceTrue"
            >确定</el-button
          >
          <el-button @click="cacelBindHighVideo">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 地磁绑定 -->
    <el-dialog
      title="地磁绑定"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisibleEquip"
      width="500px"
      @open="openDialogEquip"
    >
      <div class="nb-lora-button">
        <span
          v-bind:class="{ isBlue: nbBindVisible }"
          @click="selectGeomagnetism('nb')"
          >双模地磁</span
        >
        <span
          v-bind:class="{ isBlue: dualBindVisible }"
          @click="selectGeomagnetism('dual')"
          >双地磁</span
        >
      </div>
      <template>
        <div>
          <el-form
            ref="formEquip"
            label-position="right"
            :model="formEquip"
            :rules="rulesEquip"
            :label-width="formLabelWidth"
          >
            <el-form-item label="地磁" prop="onerankdevSn">
              <el-col :span="18">
                <el-select
                  clearable
                  v-model.trim="formEquip.onerankdevSn"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in UnbindNbDevData"
                    :key="item.id"
                    :label="item.devSn"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="nbSpaceBindEquipTrue"
              >确定</el-button
            >
            <el-button @click="cacelBindEquip">取 消</el-button>
          </div>
        </div>
      </template>
    </el-dialog>

    <!-- 读卡器绑定 -->
    <el-dialog
      title="读卡器绑定"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisibleReadcard"
      width="500px"
      @open="openDialogReadcard"
      @close="closeDialogReadcard"
    >
      <div class="nb-lora-button">
        <span
          v-bind:class="{ isBlue: nbReadcardBindVisible }"
          @click="selectNbReadcard"
          >nb读卡器</span
        >
        <span
          v-bind:class="{ isBlue: lorawanReadcardBindVisible }"
          @click="selectLorawanReadcard"
          >lorawan读卡器</span
        >
      </div>
      <template>
        <div v-if="nbReadcardBindVisible">
          <el-form
            ref="formReadcard"
            label-position="right"
            :model="formReadcard"
            :label-width="formLabelWidth"
          >
            <el-form-item label="读卡器编号">
              <el-col :span="18">
                <el-select
                  clearable
                  v-model.trim="formReadcard.onerankdevSn"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in UnbindNbReadcardData"
                    :key="item.id"
                    :label="item.devSn"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <!-- <span v-if="!spaceUseEquip.length">暂无设备可绑定</span> -->
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="zlNbSpaceBindReadcardTrue"
              >确定</el-button
            >
            <el-button @click="dialogFormVisibleReadcard = false"
              >取 消</el-button
            >
          </div>
        </div>
        <div v-if="lorawanReadcardBindVisible">
          <el-form
            ref="formEquip"
            label-position="right"
            :model="formReadcard"
            :label-width="formLabelWidth"
          >
            <el-form-item label="读卡器编号" prop="geomagnetism">
              <el-col :span="18">
                <el-select
                  clearable
                  v-model.trim="formReadcard.onerankdevSn"
                  filterable
                  placeholder="请选择"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in UnbindLorawanReadcardData"
                    :key="item.id"
                    :label="item.devSn"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-form-item>
          </el-form>
          <!-- <span v-if="!spaceUseEquip.length">暂无设备可绑定</span> -->
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="zlLorawanSpaceBindReadcardTrue"
              >确定</el-button
            >
            <el-button @click="dialogFormVisibleReadcard = false"
              >取 消</el-button
            >
          </div>
        </div>
      </template>
    </el-dialog>
    <!--批量添加车位-->
    <el-dialog
      title="批量添加车位"
      :visible.sync="batchImportSpaceDialogFormVisible"
      width="500px"
      @open="openDialogEquip"
      @closed="closeUpload"
      :close-on-click-modal="false"
      :lock-scroll="false"
    >
      <!-- 上传nb地磁或者lora地磁选项 -->
      <div class="nb-lora-button">
        <span
          v-bind:class="{ isBlue: uploadnbBindVisible }"
          @click="uploadSelectNb"
          >nb地磁</span
        >
      </div>
      <!-- 批量上传nb地磁 -->
      <div class="upload" v-show="uploadnbBindVisible">
        <div class="downloadTemplate">
          <span class="downloadButtonText">
            <span class="tip">*</span>请先
            <span @click="bulkLoadTemplateNb" class="downloadButton"
              >下载模板</span
            >，按照模板要求填入数据后，再上传文件
          </span>
        </div>
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/api/parking/bulkLoad/importSpaceAndNb"
          :multiple="false"
          accept="MultipartFile"
          :limit="1"
          :auto-upload="false"
          :on-success="fileNbSuccess"
          :on-error="fileNbError"
        >
          <span>上传文件:</span>
          <el-button size="small" type="primary" class="uploadButton"
            >点击上传</el-button
          >
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitUploadNb" size="small"
            >确 定</el-button
          >
          <el-button
            @click="batchImportSpaceDialogFormVisible = false"
            size="small"
            >取 消</el-button
          >
          <!--提示批量添加NB地磁成功情况-->
          <el-dialog
            title="提示"
            :visible.sync="batchImportResultDialogFormVisible"
            width="500px"
          >
            <div
              ref="showBatchImportResult"
              class="showBatchImportResult"
            ></div>
          </el-dialog>
        </span>
      </div>
    </el-dialog>
     <!--付款二维码-->
   <div ref="imgDialog" class="imgDialog">
      <el-dialog
        title="自助泊车二维码"
        :visible.sync="photoDialogVisible"
        width="400px"
        :lock-scroll="false"
        :close-on-click-modal="false"
      >
        <div id="qrcode"></div>
        <button class="qrcode-button" @click="onDownloadImgBtn">下载</button>
        <div class="qrcode-url">{{`${this.$codeUrl}?spaceNum=${spaceNum}`}}</div>
      </el-dialog>
    </div>
  </div>
  
</template>
<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import systemConfig from "../../../utils/globalVal"
import {
  getZlNbUnbindReadcard,
  bindZlNbReadcard,
  getZlLorawanUnbindReadcard,
  bindZlLorawanReadcard,
  getZlLorawanUnbindOnerankdev,
  bindZlLorawanOnerankdev,
  getZlNbUnbindOnerankdev,
  bindZlNbOnerankdev,
  bindNbDev,
  unbindNbDev,
  delSpace,
  getGeomagnetismsList,
  getAllStationList,
  addOrUpdateChargeRule,
  getChargeRule,
  bulkLoad,
  getUnbindEquip,
  getSpaceByArea,
  getAllSpaces,
  getOneSpace,
  getAllParkingsByEnabled,
  getAllDatas,
  getSpaceList,
  parkingBusType,
  dictValue,
  getUserList,
  getCity,
  parkAdd,
  getParkSingle,
  addMapOverlay,
  addMapOverlayl,
  setMapEvent,
  addMapControl,
  getManagerList,
  getArea,
  getAreaAllData,
  getAreaSingle,
  addEditArea,
  addEditSpace,
  getSpaceSingle,
  addEditIo,
  getIoSingle,
  addEditComp,
  getCompSingle,
  addDataComp,
  getDataSingle,
  getSpaceBindEquip,
  getSpaceEquip,
  spaceBindEquip,
  spaceUnbindEquip,
  getIoBindEquip,
  getIoEquip,
  ioBindEquip,
  ioUnbindEquip,
  qrCode,
  batchDelSpaces,
  getAllAreaByParkingId,
  fetchParkigList,
  fetchAreaList,
  fetchHighVideoList,
 blindHighVideo
} from "@/api/url";

import Paho from "../../../utils/mqttws31";

import Page from "../../commons/page";

import ChargeRule from "./components/chargeRule";
import SearchParking from "../../commons/searchParking";
import SearchArea from "../../commons/searchArea";
import QRCode from "qrcodejs2"; // 引入qrcode
import { Loading } from "element-ui";
export default {
  data() {
    return {
      BERTH_LIST_VIDEO_FIELD:systemConfig.BERTH_LIST_VIDEO_FIELD,
      spaceNum:'',
      menuKey: 1,
      dialogVisibleHighVideo: false,
      uploadnbBindVisible: false,
      // uploadloraBindVisible: false,
      // uploadzhonglianNbBindVisible:false,
      // uploadzhonglianLorawanBindVisible:false,
      batchImportResultDialogFormVisible: false,
      nbBindVisible: true,
      loraBindVisible: false,
      zhonglianNbBindVisible: false,
      zhonglianLorawanBindVisible: false,
      nbReadcardBindVisible: false,
      lorawanReadcardBindVisible: false,
      dualBindVisible: false,
      dialogFormVisibleRule: false,
      isActive: false,
      parklist_btn_rule: false,
      parkset_btn_edit: false,
      parkset_btn_addSpace: false,
      parkset_btn_editSpace: false,
      parkset_btn_bindSpace: false,
      // listPage:true,
      dialogFormVisibleEquipUnbind: false,
      batchImportSpaceDialogFormVisible: false,
      dialogFormVisible: false,
      showOrHiddenArea: 0,
      showOrHiddenSpace: 0,
      showOrHiddenPark: 0,
      pane1: "",
      moduleName: "space",
      UnbindNbDevData: [],
      UnbindZlNbDevData: [],
      UnbindZlLorawanDevData: [],
      UnbindNbReadcardData: [],
      UnbindLorawanReadcardData: [],
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      allSpace: [],
      oneAreaSpace: [],
      parkId: "",
      parkName: "",
      dataSpace: [],
      parkInfo: {},
      tableListAreaDataAll: {},
      tableListParkDataAll: {},
      tableListData: { rows: [] },
      tableListDataAll: {},
      allParkingBusType: [],
      batchDel: [],
      parkingList: [],
      areaList: [],
      formHighVideo: {},
      spaceChartData: {
        parkingId: "",
        parkingName: "",
        areaName: "",
        areaId: "",
      },
      //车位状态
      allSpaceStatus: [
        { name: "有车", value: "y" },
        { name: "无车", value: "n" },
      ],
      //室外收费规则
      formRuleOne: {
        chargeRuleId: "5",
        spaceId: "",
        freeTime: "",
        params: [
          {
            lrId: "",
            carType: "auto",
            wdStartOrEndTime: ["00:00", "00:00"],
            wdAfterHourF: "",
            wdLastHour: "",

            wdFirstPrice: "",
            wdAfterPrice: "",
            wdLastPrice: "",
            wdFreeMin: "",

            odStartOrEndTime: ["00:00", "00:00"],
            odAfterHourF: "",
            odLastHour: "",

            odFirstPrice: "",
            odAfterPrice: "",
            odLastPrice: "",
            odFreeMin: "",
          },
        ],
      },
      search: {
        pageNumber: 1,
        pageSize: 10,
        parkName: "",
        spaceNum: "",
        spaceType: "",
        spaceStatus: "",
        lotType: "",
        devSn: "",
      },
      downloadFileds: {
        停车道路: {
          field: "parkingId",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).parkingName
              : "";
          },
        },
        泊位段: {
          field: "areaId",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).areaName
              : "";
          },
        },
        泊位编号: "spaceNum",
        地磁编号: {
          field: "attr8",
          callback: (value) => {
            return value != "" && value != undefined
              ? JSON.parse(value).onerankdevDevSn
              : "";
          },
        },
        泊位类型: "spaceType",
        泊位状态: {
          field: "lotType",
          callback: (value) => {
            return value == "有效" ? "有车" : "无车";
          },
        },
      },
      vueMqtt: {
        hostname: "mosquitto.52zhysq.com",
        // hostname : '129.28.70.87',
        port: 3001,
        timeout: 5,
        keepAlive: 50,
        cleanSession: false,
        useTLS: true,
        userName: "",
        password: "",

        topic: "",
        reconnectTimeout: 2000,
        client: null,
      },
      areaInfo: {
        id: "",
        areaName: "",
        name: "",
        width: 52,
        height: 52,
        background: "",
        size: 50,
        x: 10,
        y: 10,
        table: "",
        scale: "1",
      },

      headTitle: "场区管理",
      defaultProps: {
        children: "children",
        label: "label",
      },

      formLabelWidth: "100px",
      allType: [
        {
          labelZhCh: "室内",
          value: "onsize",
        },
        {
          labelZhCh: "路侧",
          value: "roadside",
        },
      ],
      allCity: [],
      allManager: [],
      allChargeRule: [
        {
          name: "路侧",
          id: "1",
        },
      ],

      map: {},
      dialogFormVisibleArea: false,
      areaAllType: [
        {
          label: "地上",
          value: "1",
        },
        {
          label: "地下",
          value: "0",
        },
      ],
      bgImgAllType: [
        {
          label: "是",
          value: "1",
        },
        {
          label: "否",
          value: "0",
        },
      ],
      formArea: {
        id: "",
        name: "",
        type: "1",
        width: "",
        height: "",
        bgImgUrl: "",
        bgImgType: "1",
      },
      rulesArea: {
        name: [
          { required: true, message: "请填写泊位编号", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 2 到 5 个字符", trigger: "blur" },
        ],
        parkingName: [
          {
            required: true,
            message: "请填写停车道路名称",
            trigger: ["blur", "change"],
          },
        ],
        areaName: [
          {
            required: true,
            message: "请填写泊位段名称",
            trigger: ["blur", "change"],
          },
        ],
      },

      dialogFormVisibleSpace: false,

      spaceAllType: [
        {
          labelZhCh: "普通车位",
          value: "common",
        },
        {
          labelZhCh: "vip车位",
          value: "vip",
        },
        {
          labelZhCh: "临时车位",
          value: "temporary",
        },
        {
          labelZhCh: "私人车位",
          value: "private",
        },
      ],
      allUser: [],
      userShow: false,
      formSpace: {
        parkingId: "",
        areaId: "",
        id: "",
        userId: "",
        number: "",
        type: "common",
        toward: "1",
        angle: 0,
        zoom: 100,
        x: 3,
        y: 6,
        status: "normal", //异常类型
        lotType: "n", //有无车
      },
      rulesSpace: {
        number: [
          {
            required: true,
            trigger: "blur",
            type: "number",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (value != "") {
                // if (/^\d{1,7}$/.test(value) == false) {
                //   callback(new Error("请填写1到7位数字"));
                // } else {
                  callback();
                // }
              } else {
                callback(new Error("请填写车位号"));
              }
            },
          },
        ],
        parkingId: [
          {
            required: true,
            message: "请选择道路",
            trigger: ["blur", "change"],
          },
        ],
        areaId: [
          {
            required: true,
            message: "请选择岗位",
            trigger: ["blur", "change"],
          },
        ],
      },

      mapOrBind: true,
      spaceEquipList: [],
      spaceBindedList: [],

      dialogFormVisibleEquip: false,
      spaceUseEquip: [],
      formEquip: {
        spaceId: "",
        onerankdevSn: "",
        devId: "",
        stationSn: "",
      },

      dialogFormVisibleReadcard: false,
      formReadcard: {
        spaceId: "",
        onerankdevSn: "",
        // devId:'',
        // stationSn:''
      },

      allStations: {},
      geomagnetismsList: {},
      rulesEquip: {
        sn: [{ required: true, message: "请选择sn", trigger: ["blur"] }],
      },

      dialogFormVisibleBase: false,
      highVideoList: [],
      photoDialogVisible:false,
      pageObj:{},
      loading: false,
      downloadLoading: false,
    };
  },
  //将后台返回的数据格式化
  filters: {
    handleLotType: function(value) {
      var resultValue;
      switch (value) {
        case "n":
          resultValue = "无车";
          break;
        case "y":
          resultValue = "有车";
          break;
        case "无效":
          resultValue = "无车";
          break;
        case "有效":
          resultValue = "有车";
          break;
        default:
          resultValue = "";
          break;
      }
      return resultValue;
    },
  },
  components: {
    Page,

    SearchParking,
    SearchArea,
    // Refresh
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    //创建MQTT连接
    MQTTconnect: function() {
      this.vueMqtt.client = new Paho.MQTT.Client(
        this.vueMqtt.hostname,
        this.vueMqtt.port,
        "web_" + parseInt(Math.random() * 100, 10)
      );
      var options = {
        invocationContext: {
          host: this.vueMqtt.hostname,
          port: this.vueMqtt.port,
          path: this.vueMqtt.client.path,
          clientId: "web_" + parseInt(Math.random() * 100, 10),
        },
        timeout: this.vueMqtt.timeout,
        keepAliveInterval: this.vueMqtt.keepAlive,
        cleanSession: this.vueMqtt.cleanSession,
        useSSL: this.vueMqtt.useTLS,
        userName: this.vueMqtt.userName,
        password: this.vueMqtt.password,
        onSuccess: this.onConnect,
        onFailure: this.onFailure,
      };
      // this.vueMqtt.client.onConnectionLost = this.onConnectionLost;
      // this.vueMqtt.client.onMessageArrived = this.onMessageArrived;
      this.vueMqtt.client.connect(options);
    },
    //连接中
    onConnect: function() {
      console.log("车位 Mqtt connected");
      this.vueMqtt.client.subscribe(this.vueMqtt.topic);
    },
    //连接失败
    onFailure: function() {
      console.log("error");
      setTimeout(this.MQTTconnect, this.vueMqtt.reconnectTimeout);
    },
    //失去连接
    onConnectionLost: function(responseObject) {
      setTimeout(this.MQTTconnect, this.vueMqtt.reconnectTimeout);
    },
    //收到消息
    onMessageArrived: function(message) {
      var mqttPd = JSON.parse(message.payloadString);
      if (this.treeData.areaId == mqttPd.data.parkingArea.areaId) {
        this.tableList(
          this.page.curIndex,
          _this.treeData.parkingId,
          _this.treeData.areaId
        );
        var parkArea = mqttPd.data.parkingArea;
        this.$refs.spaceStatus.tableListChart(this.treeData.areaId);
      }
    },
    handleDevSnNum(attr3) {
      var t = "";
      if (attr3) {
        if (JSON.parse(attr3).onerankdevDevSn == undefined) {
          t = JSON.parse(attr3).devSn;
        } else {
          t = JSON.parse(attr3).onerankdevDevSn;
        }
      }

      return t;
    },
    handleReadcardNum(attr4) {
      var t = "";

      if (attr4) {
        t = JSON.parse(attr4).devSn;
      }
      return t;
    },
    batchImportSpace() {
      this.batchImportSpaceDialogFormVisible = true;
      // this.$refs.upload.clearFiles();
    },
    //批量上传
    submitUploadNb() {
      this.batchImportDialogFormVisible = false;
      this.$refs.upload.submit();
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    // nb地磁批量上传提示
    fileNbSuccess(response, file, fileList) {
      var _this = this;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
      this.batchImportResultDialogFormVisible = true;
      let span = document.createElement("span");
      this.$nextTick(function() {
        this.$refs.showBatchImportResult.innerHTML = "";
        span.innerHTML = response.data;
        _this.$refs.showBatchImportResult.appendChild(span);
      });
    },

    fileNbError(err, file, fileList) {
      // console.log(err)
    },
    closeUpload() {
      this.$refs.upload.clearFiles();
      // this.$refs.uploadTwo.clearFiles();
    },
    spaceChargeRule(id, objCharge) {
      this.$refs.spaceChargeRule.getChargeRule(id, objCharge);
    },

    bulkLoadTemplateNb() {
      window.open("/api/parking/bulkLoad/importTemplate", "_self");
    },
    // 批量导入
    uploadSelectNb() {
      this.uploadnbBindVisible = true;
      // this.uploadloraBindVisible = false;
    },
    uploadSelectLora() {
      this.uploadnbBindVisible = false;
      // this.uploadloraBindVisible = true;
    },
    prev: function() {
      // this.listPage=true;
      this.showOrHiddenSpace = false;
      if (this.treeData.areaId != "") {
        this.showOrHiddenArea = true;
      } else {
        this.showOrHiddenPark = true;
      }
    },
    // 导出数据
    tableListDataAllTwoNb: function() {
      const { spaceNum, devSn, lotType } = this.search;
      this.downloadLoading = true;
      this.$downloadFileRequest(
        "/api/parking/parkingSpace/berthNbExportExcel",
        {
          parkingId: this.parking?.parkingId ?? null,
          areaId: this.area?.areaId ?? null,
          spaceNum: spaceNum ? spaceNum : null,
          devSn: devSn ? devSn : null,
          lotType: lotType ? lotType : null,
        },
        "泊位"
      ).finally(() => {
        this.downloadLoading = false;
      });
    },
    tableListDataAllTwoLora: function() {
      window.open(
        `/api/parking/parkingSpace/loraBerthExportExcel?areaId=${this.treeData.areaId}`,
        "_self"
      );
      // }
    },
    //搜索车位，参数车位编号，停车场Id
    searchSpace: function() {},
    //列表筛选是否有车
    filterHandlerLotType(value, row) {
      return row.lotType === value;
    },
    //列表筛选车位类型
    filterHandlerSpaceType(value, row) {
      return row.spaceType === value;
    },
    //列表筛选车位状态
    filterHandlerSpaceStatus(value, row) {
      return row.spaceStatus === value;
    },
    //列表筛选通用
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //获取某一停车场的所有岗位信息
    tableListAreaAll: function(id) {
      this.$get(getAllAreaByParkingId(), {
        parkingId: id,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.tableListAreaDataAll = data.data;
      });
    },
    openDialogEquip: function() {
      this.getAllStations();
      // this.getZlUnbindNbDev();
      // this.getZlUnbindLorawanDev();
      // this.getUnbindNbDev();
    },
    closeDialogEquip: function() {
      this.formEquip.stationSn = "";
      this.formEquip.onerankdevSn = "";
      this.geomagnetismsList = {};
      this.$refs["formEquip"].resetFields();
    },
    openDialogReadcard: function() {
      this.formReadcard.onerankdevSn = "";
      this.getZlUnbindLorawanReadcard();
      this.getZlUnbindNbReadcard();
    },
    closeDialogReadcard: function() {
      // this.formEquip.stationSn='';
      // this.formEquip.onerankdevSn='';
      // this.geomagnetismsList={};
      // this.$refs['formEquip'].resetFields();
    },
    //获取所有的停车场名称
    tableListParkAll: function() {
      this.$get(getAllParkingsByEnabled()).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        this.tableListParkDataAll = data.data;
        //console.log("tableListDataAll")
        //console.log(this.tableListData.rows)
      });
    },
    //获取所有的停车位信息
    tableListAll: function() {
      this.$get(getAllSpaces(), {}).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        var rows = data.data.rows;
        this.tableListDataAll = data.data;
      });
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    spaceBindEquip: function(id) {
      this.formEquip.spaceId = id;
      this.dialogFormVisibleEquip = true;
      this.nbBindVisible = false;
      this.loraBindVisible = false;
      this.zhonglianNbBindVisible = false;
      this.zhonglianLorawanBindVisible = false;
    },

    cacelBindEquip() {
      this.dialogFormVisibleEquip = false;
      this.dualBindVisible = false;
      this.nbBindVisible = false;
      this.resetForm("formEquip");
      this.UnbindNbDevData = [];
    },
    nbSpaceBindEquipTrue: function() {
      var _this = this;
      this.$refs["formEquip"].validate(function(valid, noStri) {
        if (valid) {
          _this.dialogFormVisibleEquip = false;
          _this
            .$postRequest(bindNbDev(), {
              attr3: _this.formEquip.onerankdevSn,
              spaceId: _this.formEquip.spaceId,
            })
            .then((data) => {
              if (data.status != 200) return _this.$layer.msg(data.message);
              _this.$notify({
                title: "成功",
                type: "success",
                message: "绑定成功",
              });
              _this.tableList(_this.page.curIndex);
            })
            .finally(() => {
              _this.dualBindVisible = false;
              _this.nbBindVisible = false;
              _this.resetForm("formEquip");
              _this.UnbindNbDevData = [];
            });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    spaceBindReadcard: function(id) {
      this.formReadcard.spaceId = id;
      this.dialogFormVisibleReadcard = true;
      this.nbReadcardBindVisibl = false;
      this.lorawanReadcardBindVisible = false;
      // this.unbindEquipList(id);
    },
    zlNbSpaceBindReadcardTrue: function() {
      var _this = this;
      _this.dialogFormVisibleReadcard = false;
      _this
        .$postRequest(bindZlNbReadcard(), {
          attr4: _this.formReadcard.onerankdevSn,
          spaceId: _this.formReadcard.spaceId,
        })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          _this.$notify({
            title: "成功",
            type: "success",
            message: "绑定成功",
          });
          _this.tableList(_this.page.curIndex);
        });
    },
    zlLorawanSpaceBindReadcardTrue: function() {
      var _this = this;
      _this.dialogFormVisibleReadcard = false;
      _this
        .$postRequest(bindZlLorawanReadcard(), {
          attr4: _this.formReadcard.onerankdevSn,
          spaceId: _this.formReadcard.spaceId,
        })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          _this.$notify({
            title: "成功",
            type: "success",
            message: "绑定成功",
          });
          _this.tableList(_this.page.curIndex);
        });
    },
    onRoadChange(id) {
      this.getHighVideoList(id);
    },
    getHighVideoList(parkingId) {
      return this.$get(fetchHighVideoList(), {
        parkingId,
      }).then((data) => {
        if (data?.status !== 200) return;
        this.highVideoList = data?.data ?? [];
      });
    },
    async spaceBindHighVideo(spaceId) {
      this.formHighVideo = {};
      this.dialogVisibleHighVideo = true;
      this.formHighVideo.spaceId = spaceId;
      await this.getParkingList();
    },
    highVideoBindSpaceTrue() {
      this.$postRequest(blindHighVideo(), {
        attr3: this.formHighVideo.highVideoSn,
        spaceId: this.formHighVideo.spaceId,
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        this.$notify({
          title: "成功",
          type: "success",
          message: "绑定成功",
        });
        this.tableList(this.page.curIndex);
        this.dialogVisibleHighVideo = false;
      });
    },
    cacelBindHighVideo() {
      this.dialogVisibleHighVideo = false;
    },
    spaceUnbindEquipSure: function(id, tip) {
      var _this = this;
      _this.dialogFormVisibleEquip = false;
      if (tip == "dev") {
        _this
          .$putRequest(addEditSpace() + "/" + id, {
            attr3: "",
            spaceId: id,
          })
          .then((data) => {
            if (data.status != 200) return _this.$layer.msg(data.message);
            _this.$notify({
              title: "成功",
              type: "success",
              message: "解绑成功",
            });
            _this.tableList(_this.page.curIndex);
          });
      }

      if (tip == "high-video") {
        _this
          .$putRequest(addEditSpace() + "/" + id, {
            attr3: "",
            spaceId: id,
          })
          .then((data) => {
            if (data.status != 200) return _this.$layer.msg(data.message);
            _this.$notify({
              title: "成功",
              type: "success",
              message: "解绑成功",
            });
            _this.tableList(_this.page.curIndex);
          });
      }
    },
    handleBack: function() {
      this.mapOrBind = true;
    },
    getSpaceType: function() {
      this.$get(dictValue() + "/space_type").then((data) => {
        this.spaceAllType = data.data.rows;
      });
    },
    getAllUser: function() {
      this.$get(getUserList(), {
        mobile: "",
        limit: "0",
      }).then((data) => {
        if (data.status != 200) return;
        this.allUser = data.data.rows;
      });
    },

    handleNodeClick: function(data) {
      this.currentComp = data;
    },

    getParkingBusType: function() {
      this.$get(parkingBusType()).then((data) => {
        this.allParkingBusType = data;
      });
    },
    getParkType: function() {
      this.$get(dictValue() + "/parking_type").then((data) => {
        this.allType = data.data.rows;
      });
    },

    getCity: function() {
      this.$get(getCity(), {
        arealevel: "2",
        name: "",
        limit: "0",
      }).then((data) => {
        if (data.status != 200) return;
        this.allCity = data.data.rows;
      });
    },
    changeCity: function(val) {
      let obj = {};
      obj = this.allCity.find((item) => {
        return item.id === val;
      });
      // console.log(obj.name);
      this.map.centerAndZoom(obj.name, 12);
    },
    openDialog: function() {},
    closeDialog: function() {
      this.$refs["form"].resetFields();
    },

    openDialogArea: function() {},
    closeDialogArea: function() {
      // this.$refs['form'].resetFields();
      this.$refs["formArea"].resetFields();
    },

    handleError(rr, file, fileList) {
      // console.log(file, fileList);
    },
    handleSuccess(response, file, fileList) {
      this.formArea.bgImgUrl = response.data;
    },

    openDialogSpace: function() {},
    closeDialogSpace: function() {
      this.$refs["formSpace"].resetFields();
      this.formSpace.type = "common";
      this.tableListAreaDataAll = {};
      this.parkInfo.parkingName = "";
      this.areaInfo.areaName = "";
    },
    changeSpaceType: function(val) {
      if (val == "private") {
        this.userShow = true;
      } else {
        this.userShow = false;
      }
    },
    addSpace: async function() {
      this.getParkingList();
      this.dialogFormVisibleSpace = true;
      this.formSpace.id = "";
      this.formSpace.number = "";
      this.formSpace.parkingName = "";
      this.formSpace.areaName = "";
      // this.formSpace.status=data.data.spaceStatus;
      this.formSpace.parkingId = "";
      this.formSpace.areaId = "";
      this.userShow = false;
    },

    delSpace: function(id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该车位吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function() {
          _this.$layer.close(index);
          _this.$deleteRequest(delSpace() + "/" + id, {}).then((data) => {
            if (data.status == 200) {
              _this.$notify({
                type: "success",
                message: "删除成功",
                title: "成功",
              });
              _this.tableList(_this.page.curIndex);
            } else {
              data.status == 231;
              _this.$notify.error({
                message: "该泊位下有绑定的地磁，请先解绑地磁！",
                title: "失败",
              });
            }
          });
        }
      );
    },

    editSpace: function(id) {
      this.getParkingList();

      // this.selectedArea = true;
      // this.areaList = false;
      this.$get(getOneSpace(), { spaceId: id }).then((data) => {
        if (data.status !== 200) return;
        const tempData = data?.data ?? {};
        if (Object.keys(tempData).length > 0) {
          this.formSpace = {
            id: tempData.spaceId,
            number: tempData.spaceNum,
            type: tempData.spaceType,
            parkingName: this.isJSONString(tempData.parkingId)
              ? JSON.parse(tempData.parkingId).parkingName
              : "",
            areaName: this.isJSONString(tempData.areaId)
              ? JSON.parse(tempData.areaId).areaName
              : "",
            parkingId: this.isJSONString(tempData.parkingId)
              ? JSON.parse(tempData.parkingId).parkingId
              : "",
            areaId: this.isJSONString(tempData.areaId)
              ? JSON.parse(tempData.areaId).areaId
              : "",
            toward: tempData.toward,
            angle: tempData.angle,
            x: tempData.abscissa,
            y: tempData.ordinate,
            userId: tempData.userId,
          };
        }
        this.getAreaList(this.formSpace.parkingId);
        if (tempData.spaceType == "private") {
          this.userShow = true;
        } else {
          this.userShow = false;
        }
        this.dialogFormVisibleSpace = true;
      });
    },
    addEditSpaceTrue: function() {
      var _this = this;
      this.$refs["formSpace"].validate(function(valid, noStri) {
        if (valid) {
          _this.dialogFormVisibleSpace = false;

          if (!Boolean(_this.formSpace.id)) {
            _this
              .$postRequest(addEditSpace(), {
                // parkingId:_this.formSpace.parkingId,
                areaId: _this.formSpace.areaId,

                // spaceId:_this.formSpace.id,
                spaceNum: _this.formSpace.number,
                spaceType: _this.formSpace.type,
                userId:
                  _this.formSpace.type == "private"
                    ? _this.formSpace.userId
                    : "",

                abscissa: _this.formSpace.x,
                ordinate: 2,
                toward: _this.formSpace.toward,
                angle: _this.formSpace.angle,
                zoom: _this.formSpace.zoom,

                spaceStatus: _this.formSpace.status,
                lotType: _this.formSpace.lotType,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加泊位成功！",
                });

                _this.search.pageNumber = 1;

                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(addEditSpace() + "/" + _this.formSpace.id, {
                // parkingId:_this.formSpace.parkingId,
                areaId: _this.formSpace.areaId,

                spaceId: _this.formSpace.id,
                spaceNum: _this.formSpace.number,
                spaceType: _this.formSpace.type,
                userId:
                  _this.formSpace.type == "private"
                    ? _this.formSpace.userId
                    : "",

                abscissa: _this.formSpace.x,
                ordinate: _this.formSpace.y,
                toward: _this.formSpace.toward,
                angle: _this.formSpace.angle,
                zoom: _this.formSpace.zoom,

                spaceStatus: _this.formSpace.status,
                lotType: _this.formSpace.lotType,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改泊位信息成功！",
                });
                // console.log(_this.treeData.parkingId);
                // console.log(_this.treeData.areaId);
                _this.tableList(_this.page.curIndex);
                // _this.$refs.spaceStatus.tableListChart(_this.treeData.areaId);
                //_this.$refs.areaTree.getAllDatas(_this.parkInfo.parkingId);
                //_this.getMapInfo(_this.areaInfo,true);
              });
          }
        }
      });
    },

    getAreasByParkingId: function(value) {
      this.getAreaList(value);
    },

    getParkingList() {
      return this.$get(fetchParkigList()).then((res) => {
        const { status, data } = res;
        if (status === 200) {
          this.parkingList = data;
        }
      });
    },
    getAreaList(id) {
      if (id) {
        this.$get(fetchAreaList(), { parkingId: id }).then((res) => {
          const { status, data } = res;
          if (status === 200) {
            this.areaList = data;
          }
        });
      } else {
        this.areaList = [];
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      this.$get(getSpaceList(), {
        parkingId: this.parking?.parkingId ?? null,
        areaId: this.area?.areaId ?? null,
        limit: this.search.pageSize,
        spaceNum: this.search.spaceNum,
        devSn: this.search.devSn,
        lotType: this.search.lotType,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        //this.search.pageNumber=data.data.offset;
        var rows = data.data.rows;
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows;
        _this.allSpace = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.loading = false;
      });
    },

    changeArea: function() {
      this.areaInfo.id = 160;
      this.getMapInfo();
    },
    handleMousedown: function(e) {
      var table = this.$refs["workTable"];

      var target = e.target || e.srcElement;
      var _name = target.nodeName;

      if (_name == "DIV") {
        this.controlMouse.targetDiv = target;
        this.controlMouse.parentDiv = target.parentNode;
        this.controlMouse.tdStyle = target.parentNode.getAttribute("style");
        this.controlMouse.tdClass = target.parentNode.getAttribute("class");
      }

      if (this.controlMouse.targetDiv) {
        this.controlMouse.targetDiv.onselectstart = function() {
          return false;
        };
      }
    },
    handleMouseup: function(e) {
      // console.log(e.target)
      var target = e.target || e.srcElement;
      var _name = target.nodeName;

      if (_name == "TD" && this.controlMouse.tdClass) {
        var x = target.cellIndex + 1;
        var y = target.parentNode.rowIndex + 1;
        var component_data = this.controlMouse.tdClass.split("_");
        var component_type = component_data[2];
        var component_id = (component_data[4] + " ").split(" ")[0];

        // console.log(component_type,component_id,x,y);

        if (component_type == "1") {
          this.$putRequest(addEditSpace() + "/" + component_id, {
            // parkingId:this.parkId,
            // areaId:this.areaInfo.id,

            spaceId: component_id,
            abscissa: x,
            ordinate: y,
          }).then((data) => {
            if (data.status != 200) return;
            this.getMapInfo(this.areaInfo, true);
          });
        } else if (component_type == "2") {
          this.$putRequest(addEditIo() + "/" + component_id, {
            parkingId: this.parkId,
            parkingAreaId: this.areaInfo.id,

            parkingIoId: component_id,
            x: x,
            y: y,
          }).then((data) => {
            if (data.status != 200) return;
            this.getMapInfo(this.areaInfo, true);
          });
        } else if (component_type == "99") {
          this.$putRequest(addDataComp() + "/" + component_id, {
            parkingId: this.parkId,
            parkingAreaId: this.areaInfo.id,

            componentDataId: component_id,
            x: x,
            y: y,
          }).then((data) => {
            if (data.status != 200) return;
            this.getMapInfo(this.areaInfo, false);
          });
        }

        this.controlMouse = {}; //重置
      }
    },

    openDialogBase: function() {},
    closeDialogBase: function() {
      this.$refs["formBase"].resetFields();
    },

    addEditBaseTrue: function() {
      var componentType = this.formBase.typeCode;
      if (componentType == "1") {
        this.$putRequest(addEditSpace() + "/" + this.formBase.id, {
          parkingId: this.parkId,
          areaId: this.areaInfo.id,

          spaceId: this.formBase.id,

          // abscissa:this.formBase.x,
          // ordinate:this.formBase.y,
          toward: this.formBase.toward,
        }).then((data) => {
          // console.log("从接口获取更改后的数据成功");
          if (data.status != 200) return;
          this.getMapInfo(this.areaInfo, true);
        });
      } else if (componentType == "2") {
        this.$putRequest(addEditIo() + "/" + this.formBase.id, {
          parkingId: this.parkId,
          parkingAreaId: this.areaInfo.id,

          parkingIoId: this.formBase.id,

          // x:this.formBase.x,
          // y:this.formBase.y,
          angle: this.formBase.angle,
        }).then((data) => {
          if (data.status != 200) return;
          this.getMapInfo(this.areaInfo, true);
        });
      } else if (componentType == "99") {
        this.$putRequest(addDataComp() + "/" + this.formBase.id, {
          parkingId: this.parkId,
          parkingAreaId: this.areaInfo.id,

          componentDataId: this.formBase.id,

          // x:this.formBase.x,
          // y:this.formBase.y,
          angle: this.formBase.angle,
        }).then((data) => {
          if (data.status != 200) return;
          this.getMapInfo(this.areaInfo, true);
        });
      }
      this.dialogFormVisibleBase = false;
    },
    removeBase: function() {
      var componentType = this.formBase.typeCode;
      if (componentType == "1") {
        this.$putRequest(addEditSpace() + "/" + this.formBase.id, {
          parkingId: this.parkId,
          areaId: this.areaInfo.id,

          spaceId: this.formBase.id,
          enabledFlag: "n",
          abscissa: 0,
          ordinate: 0,
        }).then((data) => {
          if (data.status != 200) return;
          this.getMapInfo(this.areaInfo, true);
        });
      } else if (componentType == "2") {
        this.$putRequest(addEditIo() + "/" + this.formBase.id, {
          parkingId: this.parkId,
          parkingAreaId: this.areaInfo.id,

          parkingIoId: this.formBase.id,

          x: 0,
          y: 0,
        }).then((data) => {
          if (data.status != 200) return;
          this.getMapInfo(this.areaInfo, true);
        });
      } else if (componentType == "99") {
        this.$deleteRequest(addDataComp() + "/" + this.formBase.id).then(
          (data) => {
            if (data.status != 200) return;
            this.getMapInfo(this.areaInfo, true);
          }
        );
      }
      this.dialogFormVisibleBase = false;
    },
    unbindEquipList(id) {
      this.currentComp.spaceId = id;
      this.$get(getUnbindEquip(), {
        devType: 212,
        spaceId: id,
      }).then((data) => {
        this.spaceUseEquip = data.data.rows;
        this.tableList(this.page.curIndex);
      });
    },
    getChargeRule: function(spaceId) {
      this.dialogFormVisibleRule = true;
      this.formRuleOne.spaceId = spaceId;
      this.$get(getChargeRule(), {
        spaceId: spaceId,
        chargeRuleId: "5",
      }).then((data) => {
        if (data.status != 200) return;
        var result = data.data;
        for (var i = 0; i < result.length; i++) {
          if (result[i].carType == "auto") {
            this.formRuleOne.freeTime = result[i].wdFreeMin;

            for (var k in result[i]) {
              this.formRuleOne.params[0][k] = result[i][k];
            }

            this.formRuleOne.params[0].wdStartOrEndTime = [
              result[i].wdStartTime,
              result[i].wdEndTime,
            ];

            this.formRuleOne.params[0].odStartOrEndTime = [
              result[i].odStartTime,
              result[i].odEndTime,
            ];
          }
        }
      });
    },
    addrOrEditRuleTrue: function() {
      this.dialogFormVisibleRule = false;
      this.$postRequest(addOrUpdateChargeRule(), {
        chargeRuleId: "5",
        params: [
          {
            spaceId: this.formRuleOne.spaceId,
            carType: this.formRuleOne.params[0].carType,

            lrId: this.formRuleOne.params[0].lrId,

            wdStartTime: this.formRuleOne.params[0].wdStartOrEndTime[0],
            wdEndTime: this.formRuleOne.params[0].wdStartOrEndTime[1],

            wdAfterHourF: this.formRuleOne.params[0].wdAfterHourF,
            wdFirstHour: this.formRuleOne.params[0].wdAfterHourF,
            wdAfterHourL: this.formRuleOne.params[0].wdLastHour,
            wdLastHour: this.formRuleOne.params[0].wdLastHour,

            wdFirstPrice: this.formRuleOne.params[0].wdFirstPrice,
            wdAfterPrice: this.formRuleOne.params[0].wdAfterPrice,
            wdLastPrice: this.formRuleOne.params[0].wdLastPrice,
            wdFreeMin: this.formRuleOne.freeTime,

            odStartTime: this.formRuleOne.params[0].odStartOrEndTime[0],
            odEndTime: this.formRuleOne.params[0].odStartOrEndTime[1],

            odAfterHourF: this.formRuleOne.params[0].odAfterHourF,
            odFirstHour: this.formRuleOne.params[0].odAfterHourF,
            odAfterHourL: this.formRuleOne.params[0].odLastHour,
            odLastHour: this.formRuleOne.params[0].odLastHour,

            odFirstPrice: this.formRuleOne.params[0].odFirstPrice,
            odAfterPrice: this.formRuleOne.params[0].odAfterPrice,
            odLastPrice: this.formRuleOne.params[0].odLastPrice,
            odFreeMin: this.formRuleOne.freeTime,
          },
        ],
      }).then((data) => {
        if (data.status != 200) return;
        this.$notify({
          type: "sucess",
          title: "成功",
          message: "收费规则设置成功！",
        });
      });
    },

    getAllStations() {
      this.$get(getAllStationList()).then((data) => {
        if (data.status != 200) return;
        this.allStations = data.data;
      });
    },
    selectStation(value) {
      if (!value) {
        this.geomagnetismsList = {};
        this.formEquip.onerankdevDevSn = "";
        this.formEquip.devId = "";
      } else {
        this.$get(getGeomagnetismsList(), {
          stationId: value,
        }).then((data) => {
          if (data.status != 200) return;
          this.geomagnetismsList = data.data;
        });
      }
    },
    selectDev(value) {
      this.formEquip.devId = value;
    },

    selectGeomagnetism(t) {
      this.formEquip.onerankdevSn = "";
      this.formEquip.devId = "";
      this.formEquip.stationSn = "";
      this.UnbindNbDevData = [];
      switch (t) {
        case "nb": {
          this.nbBindVisible = true;
          this.dualBindVisible = false;
          this.getUnbindDev("bosk");
          break;
        }
        case "dual": {
          this.nbBindVisible = false;
          this.dualBindVisible = true;
          this.getUnbindDev("bosk-dualMode");
          break;
        }
        default: {
          break;
        }
      }
    },
    getUnbindDev(c) {
      this.$get(unbindNbDev(), {
        company: c,
      }).then((data) => {
        if (data.status != 200) return;
        this.UnbindNbDevData = data.data;
      });
    },

    selectNbReadcard() {
      this.formReadcard.onerankdevSn = "";
      this.formReadcard.devId = "";
      this.formReadcard.stationSn = "";
      this.nbReadcardBindVisible = true;
      this.lorawanReadcardBindVisible = false;
    },
    selectLorawanReadcard() {
      this.formReadcard.onerankdevSn = "";
      this.formReadcard.devId = "";
      this.formReadcard.stationSn = "";
      this.nbReadcardBindVisible = false;
      this.lorawanReadcardBindVisible = true;
    },

    getZlUnbindNbReadcard() {
      this.$get(getZlNbUnbindReadcard(), {
        company: "zhonglian",
      }).then((data) => {
        if (data.status != 200) return;
        this.UnbindNbReadcardData = data.data;
      });
    },
    getZlUnbindLorawanReadcard() {
      this.$get(getZlLorawanUnbindReadcard(), {
        company: "zhonglian",
      }).then((data) => {
        if (data.status != 200) return;
        this.UnbindLorawanReadcardData = data.data;
      });
    },
    checkedList(val) {
      this.batchDel = val.map((item) => {
        return item.spaceId;
      });
    },

    executeBatchDel() {
      if (this.batchDel == "") {
        this.$message({
          type: "warning",
          message: "请选择要删除的对象",
        });
        return;
      }
      this.$postRequest(batchDelSpaces(), {
        ids: this.batchDel,
      }).then((data) => {
        if (data.status == 200) {
          this.$notify({
            type: "success",
            message: "批量删除成功！",
            title: "成功",
          });
          this.tableList(this.pageObj.curIndex);
          this.batchDel = [];
        }
      });
    },
    isJSONString(s) {
      try {
        const o = JSON.parse(s);
        return typeof o === "object";
      } catch (e) {}
      return false;
    },
    showQrCode(row){
      this.photoDialogVisible = true;
      this.spaceNum=row.spaceNum
      this.$nextTick(()=>{
        document.getElementById("qrcode").innerHTML=""
        let qrcodeDom = document.getElementById("qrcode");
        let qrcode = new QRCode(qrcodeDom, {
        width: 360,
        height: 360,
        colorDark: "#000",
        colorLight: "#fff",
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(`${this.$codeUrl}?spaceNum=${row.spaceNum}`); //生成另一个新的二维码
      })
     
    },
    onDownloadImgBtn() {
    
        var qrcode = document.getElementById("qrcode");
        var img = qrcode.getElementsByTagName("img")[0];
        var link = document.createElement("a");
        var url = img.getAttribute("src");
        link.setAttribute("href", url);
        link.setAttribute("download", `${this.spaceNum}.png`);
        link.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          })
        );
    
    },
    onDeviceSnClick(row){

      this.$router.push({
        path:'/main/park/parkset/geomagnetic-historical-detail',
        query:{devSn:this.handleDevSnNum(row.attr3)}
    })
    }

  },
  computed: {
    ...mapGetters(["elements"]),
    ...mapState({
      page: (state) => state.page,
      area: (state) => state.parking.area,
      parking: (state) => state.parking.oneParking,
    }),
    permiss() {
      this.parklist_btn_rule = this.elements["parklist:btn_rule"];
      this.parkset_btn_edit = this.elements["parkset:btn_edit"];

      this.parkset_btn_editArea = this.elements["parkset:btn_editArea"];
      this.parkset_btn_addArea = this.elements["parkset:btn_addArea"];

      this.parkset_btn_editSpace = this.elements["parkset:btn_editSpace"];
      this.parkset_btn_addSpace = this.elements["parkset:btn_addSpace"];
      this.parkset_btn_bindSpace = this.elements["parkset:btn_bindSpace"];

      this.parkset_btn_editIo = this.elements["parkset:btn_editIo"];
      this.parkset_btn_addIo = this.elements["parkset:btn_addIo"];
      this.parkset_btn_bindIo = this.elements["parkset:btn_bindIo"];

      this.parkset_btn_editComp = this.elements["parkset:btn_editComp"];
      this.parkset_btn_addComp = this.elements["parkset:btn_addComp"];
      this.parkset_btn_delComp = this.elements["parkset:btn_delComp"];
    },
    //重新计算oneAreaSpace
    resultOneAreaSpace: function() {
      var resultOneAreaSpace = [];
      var oneAreaSpace = this.oneAreaSpace;

      //console.log("oneAreaSpace.parkingArea")
      //console.log(oneAreaSpace.parkingArea)
      if (oneAreaSpace.parkingArea != undefined) {
        var areaName = oneAreaSpace.parkingArea.areaName;
      }
      var space = oneAreaSpace.parking_space_list;

      for (let index in space) {
        var item = {};
        item.areaName = areaName;
        item.spaceNum = space[index].spaceNum;
        item.spaceType = space[index].spaceType;
        item.spaceStatus = space[index].spaceStatus;
        item.lotType = space[index].lotType;
        resultOneAreaSpace.push(item);
      }
      return resultOneAreaSpace;
    },
    
  },
  created: function() {
    this.permiss;
  },
  mounted: function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
  },
  destroyed: function() {},
  watch: {
    elements: {
      handler: function(val, oldVal) {
        this.permiss;
      },
      deep: true, //深度
    },

    "treeData.areaId"(val, oldVal) {
      if (val != oldVal) {
        ++this.menuKey;
      }
    },
  },
};
</script>
<style scoped>
.left .panel {
  /*width:200px;*/
  font-size: 14px;
}
.panel .heading {
  padding: 2px;
  /*border-bottom: 1px solid #ddd;*/
}
.panel .heading h3 {
  padding: 0 10px;
  line-height: 30px;
}
.left .public_list {
  overflow: auto;
  height: 680px;
}

.map {
  color: #2e2e2e;
  /* position: relative!important; */
  height: 660px;
}
.map .panel-body {
  /*margin-top:-10px;*/
  width: 100%;
  /*height: 756px;*/
  padding: 0 !important;
}
.map .panel-body .map-div {
  width: 100%;
  height: 100%;
  /*border: 1px solid #ccc;*/
  overflow: auto;
}
.map .panel-body .map-div table {
  /*	border: solid 2px greenyellow;*/
  overflow: hidden;
  margin: 0;
  padding: 0;
  background-repeat: no-repeat;
  background-size: 100%;
}
.boxbgcolor {
  display: flex;
}
.content .title-bind {
  padding: 8px 8px;
  border-bottom: 1px solid #ddd;
}
.content .title-bind .backmap {
  padding: 2px 6px;
}
.content .title-bind .backmap:hover {
  cursor: pointer;
  color: #409eff;
}
.content .plist .kind {
  line-height: 34px;
  border-top: 1px solid #ddd;
  /*border-bottom: 1px solid #ddd;*/
  padding: 2px 10px;
}

.content .plist .klist li {
  padding: 2px 10px 2px 28px;
  line-height: 38px;
  /*border-bottom: 1px solid #ddd;*/
}
.el-button--text {
  font-size: 16px;
}

.el-button + .el-button {
  margin-left: 0px;
}
.el-button--text {
  color: #1bc3b4;
}
.searchCase {
  text-align: center;
  width: 70%;
}
.searchSpaceButton {
  width: 30%;
  height: 35px;
}
.searchSpace {
  margin-left: 10px;
  height: 35px;
  border: #1bc3b4 1px solid;
  margin-top: 10px;
}
.panel-default {
  border: none !important;
}
.map_workspace {
  width: 100% !important;
}

.panel {
  -webkit-box-shadow: none;
}

.pagbox {
  height: 40px !important;
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.main {
  position: relative;
}

.space {
  width: 100%;

  display: inline-block;
}
/* .searchbox{
		padding-bottom:10px;
		height:65px;
		
		
	} */
.increate {
  float: left;
  margin: 10px 15px;
  height: 34px;
}
.increate .el-button {
  padding: 10px 12px;
  height: 34px;
}
.increate .el-button span {
  display: inline-block;
  margin-bottom: 8px;
}

.table thread tr td {
  text-align: center;
}
.table thread tr td {
  display: inline-block;
  height: 40px;
  line-height: 40px;
}
.table {
  color: #606266;
}
.table tr td {
  border: none !important;
}

.panel-body .map-div table td {
  text-align: center;

  border: solid 1px #eeeeee;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center;

  position: relative;
}
.upload {
  margin: 20px auto;
  /* margin-top:0; */
}
.tip {
  color: red;
  font-size: 14px;
  display: inline-block;
  margin-right: 5px;
  vertical-align: middle;
  height: 14px;
  line-height: 14px;
}
.downloadButton {
  font-weight: bold;
  color: #278cd8;
  cursor: pointer;
}
.uploadButton {
  margin-left: 10px;
}
.table-rule {
  color: #222;
  border-spacing: 0;
  border-collapse: collapse;
}
.table-rule tr td {
  padding: 10px 10px;
  text-align: center;
  border: 1px solid #ccc;
  font-size: 14px;
}

.table-rule .money-input,
.table-rule .time-input {
  width: 40px;
  height: 26px;
  border: 1px solid #ccc;
  /* border: 1px solid #02c1af; */
  border-radius: 2px;
  text-align: center;
  color: #222;
  color: #02c1af;
}
/* .list-right{
	height:calc(100vh - 290px);
	overflow:auto!important;
    padding-bottom:40px;
     
}*/
/* .main .content{
	overflow:hidden!important;
} */
.parkset .space-list-right {
  height: calc(100vh - 330px);
  /* overflow:auto!important; */
  padding-bottom: 40px;
}
/* .space-chart-right{
	width:100%;
	overflow:auto!important;
} */
.nb-lora-button {
  margin-bottom: 20px;
  border-bottom: 1px solid #ccc;
  padding: 10px 0;
}
.nb-lora-button span {
  display: inline-block;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  border-radius: 5px;
  cursor: pointer;
}
.dialog-footer {
  display: flex;
  justify-content: center;
}
.dialog-footer button {
  margin-right: 5px;
}
.isBlue {
  color: #278cd8;
  border: 1px solid #278cd8;
  /* font-weight: bold; */
}
</style>
<style>
.parkset .form-control {
  width: 100px;
}
.devSn .form-control {
  width: 250px;
}
.parkset .space-status .el-select {
  width: 100px;
}

/* #map_div .tableList table td{
		border:none;
		border-bottom: solid 1px #EEEEEE;		
	} */
/* .el-table .cell{
		height:37px;
		line-height:37px;
	} */

.map-div .map_workspace td div {
  position: absolute;
  overflow: visible;
  color: white;
  text-shadow: 0 0 3px black;
  text-align: center;
  font-size: 12px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  width: 50px;
  height: 50px;
}

.el-table__header-wrapper,
.el-table__header {
  background-color: #f9f9fb !important;
}
.el-tabs--border-card > .el-tabs__content {
  padding: 0 !important;
  padding-bottom: 100px !important;
  position: static !important;
}
.el-tabs--border-card {
  border: none !important;
}
.table thead {
  background: #f9f9fb;
}
.prev {
  display: inline-block;
  height: 40px;
  width: 100px;
  margin: 5px 0 10px 10px;
  background: #278cd8;
  color: white;
}
.isGray,
.isGray:hover {
  border: none;
  background: #ccc;
}
.parkset .is-gray {
  color: #666!important;
}
.qrcode-button{
  padding:20px 0;
  background:none;
  cursor: pointer;
  color:#278cd8;
  font-size:20px;
  font-weight: bold;
}
</style>
